import { LgpHeroSubscription } from "../types";
import { ILgpHero } from '@sky-it-livedata/livedata-sports-design-system';
import { getDriverName } from '../utils';
import { RaceSessionType, Sport } from '../../../types/lgp';
import { isValidLgpHero } from './typeguards';
import { LgpHeroInfo, LgpHeroPodium, LgpHeroSession, UpdateLgpHeroWidgetInputSchema } from "appsync";
import { ErrorName, WidgetError } from "../../../utils/errors";

export default (obj: LgpHeroSubscription): ILgpHero => {
  if (isValidLgpHero(obj)) {
      UpdateLgpHeroWidgetInputSchema().parse(obj.data.onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId, {reportInput: true});
      const { info, session } = obj?.data.onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId;
      const { sportTag, flagImgUrl, customGpName, startDate, endDate, circuitImgUrl } = info as LgpHeroInfo;
      const { label, status, podium } = session as LgpHeroSession;

      return {
        sportTag: sportTag as Sport,
        flagImgUrl,
        customGpName,
        startDate,
        endDate,
        circuitImgUrl,
        sessionStatus: status,
        sessionName: label as RaceSessionType,
        podium: (podium as LgpHeroPodium[]).map((driver) => {
          const { customDriverSurname, customDriverName, customDriverShortName, driverImgUrl, position, flagImgUrl } =
            driver;
          return {
            customDriverName: getDriverName(customDriverSurname as string, customDriverName as string),
            customDriverShortName,
            flagImgUrl,
            driverImgUrl,
            position,
          };
        }),
      } as ILgpHero;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid subscription transformer input, Error in LgpHeroSubscription object',
      data: obj
    });
  }
};
